import { render } from "./ConfigProperty.vue?vue&type=template&id=3006c9d3&ts=true"
import script from "./ConfigProperty.vue?vue&type=script&lang=ts"
export * from "./ConfigProperty.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__